import { render } from "./documentos.vue?vue&type=template&id=442dc1ec&scoped=true"
import script from "./documentos.vue?vue&type=script&lang=js"
export * from "./documentos.vue?vue&type=script&lang=js"

import "./documentos.vue?vue&type=style&index=0&id=442dc1ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442dc1ec"]])

export default __exports__